
import React from "react";
import "./motionSurface.css";

function MotionSurface({ children, delay = 0, style = {} }) {
  return (
    <div
      className="hookora-motion-surface"
      style={{
        animationDelay: `${delay}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default MotionSurface;
